import { AdminPagingModel } from "./AdminPagingModel";
import { AuditService } from "../../services/AuditService";
import { PrintJobService } from "../../services/PrintJobService";
import { NotificationService } from "../../services/NotificationService";
import { GridBookmarkService } from "../../services/GridBookmarkService";
import { CustomFieldNameService } from "../../services/CustomFieldNameService";
import { Template } from "../../entities/Template";
import { PrintJob } from "../../entities/PrintJob";
import { Audit } from "../../entities/Audit";
import { CustomField } from "../../entities/CustomFieldName";

export class AuditAdminPagingModel extends AdminPagingModel<Audit>{
  static $inject = ['$q', 'AuditService', 'PrintJobService', 'NotificationService', 'GridBookmarkService', 'CustomFieldNameService'];
  constructor($q: ng.IQService, public auditService: AuditService,
    public printjobService: PrintJobService,
    public notificationService: NotificationService,
    gridBookmarkService: GridBookmarkService,
    public customFieldNameService: CustomFieldNameService) {
    super($q, auditService, notificationService, gridBookmarkService);
  }
  getCustomActions(): string[] {
    return ["Export"];
  }
  entityName(): string {
    return "audit";
  }
  displayName(): string {
    return "Recent Changes";
  }
  addEditAllowed(): boolean {
    return false;
  }
  deleteAllowed(): boolean {
    return false;
  }
  getColumnDefs(): ng.IPromise<void> {
    return this.$q.all([
      this.auditService.getCustomColumnDefs("auditDisplayColumns")
    ]).then((data) => {
      this.nameValuePairs = data[0];
      return this.$q.when();
    });
  }
}
